module.exports = __webpack_public_path__ + "static/media/turkeyLogo.22c8f3a5.png";